import Vue from 'vue';

import mainBlock from '@/components/layout/main/mainBlock';
import mainTitle from '@/components/layout/main/mainTitle';
import mainActions from '@/components/layout/main/mainActions';
import MainBreadcrumbs from '@/components/layout/main/MainBreadcrumbs';
import MainComments from '@/components/layout/main/MainComments';

[
    mainBlock,
    mainTitle,
    mainActions,
    MainBreadcrumbs,
    MainComments
].forEach(e => {
    Vue.component(e.name, e);
})